



































































































































































// vue
import { Component, Vue } from 'vue-property-decorator'
import { Modal } from '@/components/general'
// vuex
import { mapGetters } from 'vuex'

// componnents
import { PageHeader, BirthdayOfMonth } from '@/components'
import { DoughnutChart } from '@/components/chart'

// models
import { UserLogin } from '@/models'
import { IEmployee, SummaryEmployee, HeadquarterInterface } from '@/models/config'
import { ChartData, ChartOptions } from 'chart.js'

// constants
import { MALE } from '@/constants/OptionsEmployeeAttr'
import { ROLES_USER } from '@/constants/roles'

// utils
import { dateLibs } from '@/utils'

// services
import { EmployeeService, HeadquarterService } from '@/services/config'

import axios from 'axios'
import { APP_URL_API } from '@/constants'

@Component({
  name: 'Dashboard',
  components: {
    PageHeader,
    DoughnutChart,
    BirthdayOfMonth,
    Modal
  },
  computed: {
    ...mapGetters('auth', {
      auth: 'auth'
    })
  }
})
export default class Home extends Vue {
  title = 'Dashboard'
  birthdays: IEmployee[] = []
  headquarters: HeadquarterInterface[] = []
  ROLES_USER = ROLES_USER
  showBackupModal = false
  summaryCustomers: SummaryEmployee = {
    total: 0,
    active: 0,
    inactive: 0,
    employees: []
  }

  items = [
    {
      text: 'Aqua'
    },
    {
      text: 'Dashboard',
      active: true
    }
  ]

  isGeneratingBackup = false

  generateDatabaseBackup (): void {
    this.showBackupModal = true
  }

  async confirmBackup () {
    this.showBackupModal = false
    this.isGeneratingBackup = true
    try {
      const response = await axios.get(`${APP_URL_API}reports/generate-db-backup`, {
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'database_backup.sql')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error al generar el Backup:', error)
    } finally {
      this.isGeneratingBackup = false
    }
  }

  auth!: UserLogin
  datacollection: ChartData | null = null
  optionsChart: ChartOptions = {
    responsive: true,
    legend: {
      display: false
    }
  }

  get employeeBySex () {
    let maleTotal = 0
    let feminine = 0
    const totalEmployees = this.summaryCustomers.employees.length

    this.summaryCustomers.employees.forEach(employee => {
      if (employee.sex === MALE) {
        maleTotal++
      } else {
        feminine++
      }
    })

    return {
      male: Number(Number((maleTotal * 100) / totalEmployees).toFixed(2)),
      fem: Number(Number((feminine * 100) / totalEmployees).toFixed(2)),
      maleTotal: maleTotal,
      femTotal: feminine
    }
  }

  fillData () {
    this.datacollection = {
      labels: ['Masculino', 'Femenino'],
      datasets: [
        {
          backgroundColor: ['#4abb6d', '#bb2f78'],
          data: [this.employeeBySex.male, this.employeeBySex.fem],
          fill: true,
          steppedLine: 'middle'
        }
      ]
    }
  }

  async created () {
    this.birthdays = await EmployeeService.getBirthdaysPerMonth(dateLibs.currentMonth())
    this.headquarters = await HeadquarterService.getAllActivate()
  }

  mounted () {
    this.getSummaryEmployees()
  }

  async getSummaryEmployees () {
    this.summaryCustomers = await EmployeeService.getSummary()
    this.fillData()
  }
}
